import Route from '@ember/routing/route';

export default class SelectBankChildIndexRoute extends Route {
  async model() {
    return this.modelFor('onboarding.select-bank.child');
  }
}
